import {
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Box,
} from "@mui/material";

import Header from "../components/Header";
import Footer from "../components/Footer";

import {
  getSmsMessagesForAdminReview,
  getTranscriptionsForAdminReview,
  reviewSmsByAdmin,
  reviewTranscriptionByAdmin,
  deleteSmsByAdmin,
  deleteTranscriptionByAdmin,
} from "../network/api";
import { useEffect, useState } from "react";

export const AdminPage = () => {
  const [transcriptionsForReview, setTranscriptionsForReview] = useState();
  const [smsForReview, setSmsForReview] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [isAuthenticated, setIsAuthenticated] = useState(
    Boolean(window.localStorage.getItem("hotlineAuthenticated"))
  );
  const [adminPw, setAdminPw] = useState("");

  const handleGetForReview = async () => {
    setIsLoading(true);
    try {
      const smsRes = await getSmsMessagesForAdminReview();
      setSmsForReview(smsRes.res);
      const transcriptionsRes = await getTranscriptionsForAdminReview();
      setTranscriptionsForReview(transcriptionsRes.res);
    } catch {}
    setIsLoading(false);
  };

  useEffect(() => {
    handleGetForReview();
  }, []);

  // TODO Proper admin controls
  const handleAdminAuth = () => {
    if (adminPw === "hotlineadmin") {
      window.localStorage.setItem("hotlineAuthenticated", "true");
      setIsAuthenticated(true);
    }
  };

  if (!isAuthenticated) {
    return (
      <Container maxWidth="lg">
        <Header />
        <Grid container spacing={1} marginTop={3}>
          <Grid item xs={3}>
            <TextField
              helperText="Authenticate to continue"
              value={adminPw}
              onChange={(e) => setAdminPw(e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <Button variant="contained" onClick={handleAdminAuth}>
              Log in
            </Button>
          </Grid>
        </Grid>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Header />
      <Grid container spacing={1} marginTop={2}>
        <Grid item xs={12}>
          <Button
            onClick={handleGetForReview}
            disabled={isLoading}
            variant="contained"
          >
            Refresh messages for review
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4">SMS Messages</Typography>
        </Grid>
        {smsForReview &&
          smsForReview.map((sms) => {
            return (
              <Grid item xs={12} key={sms.id}>
                <ReviewForm sms={sms} onDelete={handleGetForReview}/>
              </Grid>
            );
          })}
      </Grid>

      <Grid container spacing={1} marginTop={2}>
        <Grid item xs={12}>
          <Typography variant="h4">Transcriptions</Typography>
        </Grid>
        {transcriptionsForReview &&
          transcriptionsForReview.map((transcription) => {
            return (
              <Grid item xs={12} key={transcription.id}>
                <ReviewForm transcription={transcription} onDelete={handleGetForReview}/>
              </Grid>
            );
          })}
      </Grid>

      <Footer />
    </Container>
  );
};

const ReviewForm = ({ sms, transcription, onDelete }) => {
  const [from, setFrom] = useState(
    sms?.fromName ?? transcription?.fromName ?? ""
  );
  const [to, setTo] = useState(sms?.toName ?? transcription?.toName ?? "");
  const [body, setBody] = useState(sms?.text ?? transcription?.text ?? "");
  const [success, setSuccess] = useState(false);

  const handleReview = async (e) => {
    e.preventDefault();
    let res;

    if (sms) {
      res = await reviewSmsByAdmin(sms.id, { from, to, body });
    } else if (transcription) {
      res = await reviewTranscriptionByAdmin(transcription.id, {
        from,
        to,
        body,
      });
    }
    if (res.success) setSuccess(true);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    let res;

    if (sms) {
      res = await deleteSmsByAdmin(sms.id);
    } else if (transcription) {
      res = await deleteTranscriptionByAdmin(transcription.id);
    }
    if (res.success) onDelete();
  };

  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="space-between"
      sx={{ p: 1, borderBottom: "2px solid black" }}
    >
      <Box display="flex" flexDirection={"column"}>
        <TextField
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          sx={{ p: 1 }}
          label="From"
        />
        <TextField
          value={to}
          onChange={(e) => setTo(e.target.value)}
          sx={{ p: 1 }}
          label="To"
        />
      </Box>
      <TextField
        multiline={true}
        sx={{ p: 1, flex: 3 }}
        rows={5}
        value={body}
        onChange={(e) => setBody(e.target.value)}
      />
      <Box display="flex" flexDirection="column">
        <Button
          variant="contained"
          sx={{ height: 40, margin: "auto" }}
          onClick={handleReview}
          disabled={success}
        >
          {success ? "Updated" : "Review"}
        </Button>
        <Button
          variant="contained"
          sx={{ height: 40, margin: "auto" }}
          onClick={handleDelete}
          disabled={success}
        >
          {"Delete"}
        </Button>
      </Box>
    </Box>
  );
};
